export default "__VITE_ASSET__ft5EhTmU__"